import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@src/environments/environment';
import { AnalyticsAdapter } from '@app/api-v2/util/analytics/analytics.adapter';

declare var dataLayer: any;

@Injectable()
export class WebAnalyticsAdapter extends AnalyticsAdapter {
  constructor(@Inject(PLATFORM_ID) private platformId: string) {
    super();
  }

  override setScreenName(name: string) {
    if (isPlatformBrowser(this.platformId)) {
      if (!environment.gtmID) {
        return;
      }
      try {
        if (dataLayer) {
          dataLayer.push({
            event: 'Pageview',
            url: name,
          });
        }
      } catch (error) {}
    }
  }

  override fireEvent(event: string, data: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (!environment.gtmID) {
        return;
      }
      try {
        if (dataLayer) {
          dataLayer.push({
            event,
            value: data,
          });
        }
      } catch (error) {}
    }
  }

  override fireBookingEvent(event: string, data: any) {
    if (isPlatformBrowser(this.platformId)) {
      if (!environment.gtmID) {
        return;
      }
      try {
        if (dataLayer) {
          const enhancedConversionData: any = {};
          if (data?.analyticsInfo?.enhanced_conversion_data?.email) {
            enhancedConversionData.email =
              data?.analyticsInfo?.enhanced_conversion_data?.email;
          }

          if (data?.analyticsInfo?.enhanced_conversion_data?.phone_number) {
            enhancedConversionData.phone_number =
              data?.analyticsInfo?.enhanced_conversion_data?.phone_number;
          }

          dataLayer.push({
            event,
            order_value: data?.analyticsInfo?.order_value,
            order_id: data?.analyticsInfo?.order_id,
            enhanced_conversion_data: enhancedConversionData,
          });
        }
      } catch (error) {}
    }
  }

  override setUserId(userId: string) {
    // TODO not implemented yet
    console.warn('TODO Web SetUserId is not implemented yet:');
  }
}
